import { Injectable, NgZone } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpResponse, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

import { BilEventSnackbarOpen } from '../services/bil-event-broker/bil-event-broker-arguments/bil-event-snackbar-open';

import { BilEventBrokerService } from '@core/services/bil-event-broker/bil-event-broker.service';
import { CoginitoIdentityDataService } from '@core/services/coginito-identity-data/coginito-identity-data.service';
import { Router } from '@angular/router';
import { BilNetworkService } from '../services/network/bil-network.service';

@Injectable()
export class BilDesktopInterceptor implements HttpInterceptor {

    public isOnline: boolean = true;

    constructor(
        private bilEventBrokerService: BilEventBrokerService,
        private coginitoIdentityDataService: CoginitoIdentityDataService,
        private router: Router,
        private zone: NgZone,
        private bilNetworkService: BilNetworkService
    ) {
        bilNetworkService.createOnline$().subscribe(isOnline => {
            this.isOnline = isOnline;
        });
    }
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        var cloneReq;
        var auth_token = this.coginitoIdentityDataService.getAuthToken();
        let timeStamp = new Date().getTime().toString();
        if (request.method == 'GET') {

            const headers = new HttpHeaders({
                'X-REQUEST-ID': timeStamp,
                'X-CHANNEL-ID': 'WEB_BIL',
                'Authorization': 'Bearer ' + auth_token
            });
            cloneReq = request.clone({ headers });

            if (request.url.endsWith('/kyc/address/PROPRIETOR_ADDRESS')) {
                const headers = new HttpHeaders({
                    'X-REQUEST-ID': timeStamp,
                    'X-CHANNEL-ID': 'WEB_BIL',
                    'Authorization': 'Bearer ' + auth_token
                });
                cloneReq = request.clone({ headers });
            }
            else if (request.url.includes('/user/getuserdetail')){
                const headers = new HttpHeaders({
                    'X-REQUEST-ID': timeStamp,
                    'X-CHANNEL-ID': 'WEB_BIL',
                    // // 'Authorization': 'Bearer ' + auth_token
                });
                cloneReq = request.clone({ headers });
            }else if(request.url.includes('application/details?fiName')) {
                const headers = new HttpHeaders({
                    'Content-Type': 'application/json',
                    'X-BIL-ID': localStorage.getItem('X-BIL-ID'),
                    'X-REQUEST-ID': timeStamp,
                    'Authorization': 'Bearer ' + auth_token,
                    'X-SOLV-ID': localStorage.getItem('X-SOLV-ID'),
                });
                cloneReq = request.clone({ headers });
            }  else if (request.url.endsWith("/getCredCardStatus")) {
                    const headers = new HttpHeaders({
                        'X-BIL-ID': localStorage.getItem('X-BIL-ID'),
                        'Authorization': 'Bearer ' + auth_token
                    });
                    cloneReq = request.clone({ headers });

            } else if(request.url.includes('/bil-fi/agreement/')
            || request.url.includes('/bil-fi/sendAgreement') ) {
                const headers = new HttpHeaders({
                    'X-BIL-ID': localStorage.getItem('X-BIL-ID'),
                    'X-REQUEST-ID': timeStamp,
                    'Authorization': 'Bearer ' + auth_token,
                    'X-SOLV-ID': localStorage.getItem('X-SOLV-ID'),
                });
                cloneReq = request.clone({ headers });
            }
            else if (request.url.endsWith('dashboard/dsk/application/bil') 
            || request.url.endsWith('dashboard/dsk/application/PL')) {
                const headers = new HttpHeaders({
                    'X-REQUEST-ID': timeStamp,
                    'X-CHANNEL-ID': 'WEB_BIL',
                    'Authorization': 'Bearer ' + auth_token,
                    'mock': 'false'
                });
                cloneReq = request.clone({ headers });
            } else if (request.url.endsWith('requirement/lead')) {
                const headers = new HttpHeaders({
                    'X-REQUEST-ID': timeStamp,
                    'X-CHANNEL-ID': 'WEB_BIL',
                    'Authorization': 'Bearer ' + auth_token,
                    'X-BIL-ID': localStorage.getItem('X-BIL-ID')
                });
                cloneReq = request.clone({ headers });
            }
            else if (request.url.endsWith('/getPartners')) {
                const headers = new HttpHeaders({
                    'X-REQUEST-ID': timeStamp,
                    'X-CHANNEL-ID': 'WEB_BIL',
                    'X-BIL-ID': localStorage.getItem('X-BIL-ID'),
                    'Authorization': 'Bearer ' + auth_token
                });
                cloneReq = request.clone({ headers });
            } else if (request.url.endsWith("/bs/status/v1")) {
                const headers = new HttpHeaders({
                    'X-CHANNEL-ID': 'WEB_BIL',
                    'X-BIL-ID': localStorage.getItem('X-BIL-ID'),
                    'Authorization': 'Bearer ' + auth_token
                });
                cloneReq = request.clone({ headers });
            } else if ('/getDocDetails') {
                const headers = new HttpHeaders({
                    'Content-Type': 'application/json',
                    'X-BIL-ID': localStorage.getItem('X-BIL-ID'),
                    'X-CHANNEL-ID': 'WEB_BIL',
                    'X-REQUEST-ID': timeStamp,
                    'Authorization': 'Bearer ' + auth_token,
                    'X-SOLV-ID': localStorage.getItem('X-SOLV-ID')
                });
                cloneReq = request.clone({ headers });
            }
            else if ('/bil-document') {
                const headers = new HttpHeaders({
                    'Content-Type': 'application/json',
                    'X-BIL-ID': localStorage.getItem('X-BIL-ID'),
                    'X-REQUEST-ID': timeStamp,
                    'Authorization': 'Bearer ' + auth_token,
                    'X-SOLV-ID': localStorage.getItem('X-SOLV-ID'),
                });
                cloneReq = request.clone({ headers });
            }
        }
        else if (request.method == 'POST') {
            if (request.url.endsWith("/is-registered-request")) {
                const headers = new HttpHeaders({
                    'X-REQUEST-ID': timeStamp,
                    'X-CHANNEL-ID': 'WEB_BIL',
                });
                cloneReq = request.clone({ headers });
            } else if(request.url.includes('/invoiceFinancing/v1/activation')) {
                const headers = new HttpHeaders({
                    'X-REQUEST-ID': timeStamp,
                    'X-CHANNEL-ID': 'WEB_BIL',
                    'X-BIL-ID': localStorage.getItem('X-BIL-ID'),
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + auth_token
                });
                cloneReq = request.clone({ headers });
            }
            else if (request.url.includes('/pan/verifyPanGst/isValid')) {
                const headers = new HttpHeaders({
                    'X-REQUEST-ID': timeStamp,
                    'X-CHANNEL-ID': 'WEB_BIL',
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + auth_token
                });
                cloneReq = request.clone({ headers });
            }
            else if (request.url.includes('/user/saveuseraudittrails') ||
                    request.url.includes('/user/saveuserdetail')){
                const headers = new HttpHeaders({
                    'X-REQUEST-ID': timeStamp,
                    'X-CHANNEL-ID': 'WEB_BIL',
                    // // 'Authorization': 'Bearer ' + auth_token
                });
                cloneReq = request.clone({ headers });
            } else if (request.url.endsWith('create-business-request') || (request.url.includes('/industry/search'))) {
                const headers = new HttpHeaders({
                    'X-REQUEST-ID': timeStamp,
                    'X-CHANNEL-ID': 'WEB_BIL',
                    'Authorization': 'Bearer ' + auth_token
                });
                cloneReq = request.clone({ headers });
            } else if (request.url.endsWith("owner/id")) {
                const headers = new HttpHeaders({
                    'X-REQUEST-ID': timeStamp,
                    'X-CHANNEL-ID': 'WEB_BIL',
                    'X-BIL-ID': localStorage.getItem('X-BIL-ID'),
                    'Authorization': 'Bearer ' + auth_token
                })
                cloneReq = request.clone({ headers });
            } else if (request.url.endsWith('/bs/upload/s3/v1') || request.url.endsWith('/bs/delete/s3/v1')) {
                const headers = new HttpHeaders({
                    'X-SOLV-ID': localStorage.getItem('X-SOLV-ID'),
                    'X-BIL-ID': localStorage.getItem('X-BIL-ID'),
                    'X-CUST-ID': localStorage.getItem('X-CUST-ID'),
                    'X-REQUEST-ID': timeStamp,
                    'X-CHANNEL-ID': 'WEB_BIL',
                    'Authorization': 'Bearer ' + auth_token
                });
                cloneReq = request.clone({ headers });
            } else if (request.url.endsWith('uploadItr')) {
                const headers = new HttpHeaders({
                    'X-SOLV-ID': localStorage.getItem('X-SOLV-ID'),
                    'X-BIL-ID': localStorage.getItem('X-BIL-ID'),
                    'X-CUST-ID': localStorage.getItem('X-CUST-ID'),
                    'X-REQUEST-ID': timeStamp,
                    'X-CHANNEL-ID': 'WEB_BIL',
                    'Authorization': 'Bearer ' + auth_token
                });
                cloneReq = request.clone({ headers });
            } else if ((request.url.endsWith('/bs/upload/v3'))
                || (request.url.endsWith('/bs/upload/perfios/v1'))) {
                const headers = new HttpHeaders({
                    'X-SOLV-ID': localStorage.getItem('X-SOLV-ID'),
                    'X-BIL-ID': localStorage.getItem('X-BIL-ID'),
                    'X-CUST-ID': localStorage.getItem('X-CUST-ID'),
                    'X-CHANNEL-ID': 'WEB_BIL',
                    'X-REQUEST-ID': timeStamp,
                    'Authorization': 'Bearer ' + auth_token
                });
                cloneReq = request.clone({ headers });
            } else if (request.url.endsWith('/fsa/upload/v2')) {
                const headers = new HttpHeaders({
                    'X-SOLV-ID': localStorage.getItem('X-SOLV-ID'),
                    'X-BIL-ID': localStorage.getItem('X-BIL-ID'),
                    'X-CUST-ID': localStorage.getItem('X-CUST-ID'),
                    'X-REQUEST-ID': timeStamp,
                    'Authorization': 'Bearer ' + auth_token
                });
                cloneReq = request.clone({ headers });
            }
            else if (request.url.includes('/mcadocupload')) {
                const headers = new HttpHeaders({
                    'X-SOLV-ID': localStorage.getItem('X-SOLV-ID'),
                    'X-BIL-ID': localStorage.getItem('X-BIL-ID'),
                    'X-CUST-ID': localStorage.getItem('X-CUST-ID'),
                    'X-CHANNEL-ID': 'WEB_BIL',
                    'X-REQUEST-ID': timeStamp,
                    'Authorization': 'Bearer ' + auth_token
                });
                cloneReq = request.clone({ headers });
            } else if (
                request.url.endsWith('/consumer-bureau/register-generate')
                || request.url.endsWith('/v1/consumer-bureau/validate')
                || request.url.endsWith('/v1/commercial-bureau/register')
                || request.url.endsWith('/v1/commercial-bureau/validate')
                || request.url.endsWith('/v1/commercial-bureau/report')
                || request.url.endsWith('/kyc/create')
            ) {
                const headers = new HttpHeaders({
                    'X-SOLV-ID': localStorage.getItem('X-SOLV-ID'),
                    'X-BIL-ID': localStorage.getItem('X-BIL-ID'),
                    'X-CUST-ID': localStorage.getItem('X-CUST-ID'),
                    'X-CHANNEL-ID': 'WEB_BIL',
                    'X-REQUEST-ID': timeStamp,
                    'Authorization': 'Bearer ' + auth_token,
                    'mock': 'false'
                });
                cloneReq = request.clone({ headers });
            } else if (request.url.endsWith('/updateCCInt')) {
                const headers = new HttpHeaders({
                    // 'X-SOLV-ID': localStorage.getItem('X-SOLV-ID'),
                    'X-BIL-ID': localStorage.getItem('X-BIL-ID'),
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Authorization': 'Bearer ' + auth_token
                });
                cloneReq = request.clone({ headers });
            } else {
                const headers = new HttpHeaders({
                    'X-REQUEST-ID': timeStamp,
                    'X-CHANNEL-ID': 'WEB_BIL',
                    'X-BIL-ID': localStorage.getItem('X-BIL-ID'),
                    'Authorization': 'Bearer ' + auth_token
                });
                cloneReq = request.clone({ headers });
            }
        } else if (request.method == 'PUT') {
            const headers = new HttpHeaders({
                'X-REQUEST-ID': timeStamp,
                'X-CHANNEL-ID': 'WEB_BIL',
                'X-SOLV-ID': localStorage.getItem('X-SOLV-ID'),
                'X-BIL-ID': localStorage.getItem('X-BIL-ID'),
                'X-CUST-ID': localStorage.getItem('X-CUST-ID'),
                'Authorization': 'Bearer ' + auth_token
            });
            cloneReq = request.clone({ headers });
        } else if (request.method == 'DELETE') {
            const headers = new HttpHeaders({
                'X-REQUEST-ID': timeStamp,
                'X-CHANNEL-ID': 'WEB_BIL',
                'X-BIL-ID': localStorage.getItem('X-BIL-ID'),
                'Authorization': 'Bearer ' + auth_token
            });
            cloneReq = request.clone({ headers });
        }

        if (this.isOnline) {
            return next.handle(cloneReq).pipe(
                tap((event: HttpEvent<any>) => {
                    if (event instanceof HttpResponse) {
                        // response handling
                    }
                }),
                catchError(err => {
                    if (err instanceof HttpErrorResponse) {
                        if (err.status === 403 || err.status === 401) {
                            localStorage.clear();
                            // this.router.navigate(['/registration/register']);
                            this.bilEventBrokerService.publish(new BilEventSnackbarOpen('Your session has expired , please login again to continue', 'error', 5000));
                            window.location.href = "/registration/register";
                        } else {
                            this.bilEventBrokerService.publish(new BilEventSnackbarOpen(err.error.errorMessage ? err.error.errorMessage : 'Something Went Wrong!', 'error', 3000));
                        }
                    }
                    return throwError(err);
                })
            );
        } else {
            this.bilEventBrokerService.publish(new BilEventSnackbarOpen('There is no internet connection, please try again', 'error', 4000));
        }

    }
}
